import { type UseQueryResult, useQuery } from 'react-query';
import { OptionAwardService } from '@wealthlane/api-services/wealthlane-award-service';

const useGetOptionAwardsGrantDetail = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      planTypeId: string;
      planTypeName: string;
      vestingScheduleId: string;
      vestingScheduleName: string;
      planId: string;
      planName: string;
      value: string;
      uniqueGrantNo: string;
      isOffline: boolean;
      optionExpirationInYears: number | null;
    }>
  | undefined,
  unknown
> => {
  const OptionAwardsGrantDetail = useQuery(
    ['getOptionAwardsGrantDetail'],
    async () => {
      return await handleRequest(OptionAwardService.getApiAwardApiAppOptionAwardGrantDetails());
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.grantName ?? '',
            planTypeId: item.planTypeId ?? '',
            planTypeName: item.planTypeName ?? '',
            vestingScheduleId: item.vestingScheduleId ?? '',
            vestingScheduleName: item.vestingScheduleName ?? '',
            planId: item.planId ?? '',
            planName: item.planName ?? '',
            value: item.grantId ?? '',
            uniqueGrantNo: item.uniqueGrantNo ?? '',
            grantIssuedDate: item.grantIssuedDate ?? '',
            isOffline: item.isOffline ?? false,
            optionExpirationInYears: item.optionExpirationInYears ?? null,
          };
        });
      },
    }
  );

  return OptionAwardsGrantDetail;
};

export default useGetOptionAwardsGrantDetail;
